module.exports = __webpack_public_path__ + "img/service-header.e7caf8e1.png";